import './index.scss';

export default function Alert({ children, variant = 'info', className='' }) {
	return (
		<div className={`wds-alert wds-alert--${variant} ${className}`}>
			<span className="wds-alert__message">{children}</span>
		</div>
	);
}
